export default __webpack_public_path__ + "bb082ea2078ca90ad1ae2499cc23660f.svg";